/* (ignored) */


//////////////////
// WEBPACK FOOTER
// min-document (ignored)
// module id = 2265
// module chunks = 42